import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { Column } from "../layout/Column";
import { FormattedMessage } from "react-intl";

export function StreamTextFallback({ onClose, src }) {
  return (
    <Modal
      title={<FormattedMessage id="video-streaming-fail.title" defaultMessage="Error in watch Stream" />}
      beforeTitle={<CloseButton onClick={onClose} />}
    >
      <Column padding center>
        <p>
          <FormattedMessage
            id="video-streaming-fail.message"
            defaultMessage="Browser has experience issues to show the stream of one of the users. Try refreshing the browser to resume streaming."
          />
        </p>
      </Column>
    </Modal>
  );
}

StreamTextFallback.propTypes = {
  onClose: PropTypes.func
};
